<template>
  <main class="designer" v-if="payload">
    <div class="designer__information">
      <div class="designer__information-about">
        <h1 v-html="designerName" class="title ff-sans fs-xl"></h1>
        <div class="designer__information-about--year">
          <ul>
            <li v-for="(year, key) in years" :key="`year${key}`" v-html="year"></li>
          </ul>
        </div>
        <p v-html="payload.designer.description"></p>
      </div>
      <div class="designer__information-info">
        <div class="designer__information-info--year">
          <p v-html="'Years'" v-if="years.length > 1" class="ttu"></p>
          <p v-html="'Year'" class="ttu" v-else></p>
          <ul>
            <li v-for="(year, key) in years" :key="`year${key}`" v-html="year"></li>
          </ul>
        </div>
        <div class="designer__information-info--website" v-if="payload.designer.website.link">
          <p class="ttu">Website</p>
          <a :href="payload.designer.website.link" v-html="payload.designer.website.name" target="_blank" rel="noopener noreferrer"></a>
        </div>
      </div>
    </div>
    <div
      v-if="payload.designer.work"
      class="designer__work">
      <div class="designer__work-container" v-if="payload.designer.work.work.length > 0">
        <div class="work" v-if="payload">
          <div class="work__items">
            <designer-work-item v-for="(item, key) in payload.designer.work.work" :key="`work${key}`" :item="item" :uri="'work'"></designer-work-item>
          </div>
        </div>
      </div>
      <div class="designer__work-container" v-if="payload.designer.work.research.length > 0">
        <p class="mb-1 ttu">Research</p>
        <div class="work" v-if="payload">
          <div class="work__items">
            <designer-work-item v-for="(item, key) in payload.designer.work.research" :key="`work${key}`" :item="item" :uri="'research'"></designer-work-item>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import DataService from '@/services/data-service'
import MetaService from '@/services/meta-service'

import DesignerWorkItem from '@/views/designers/DesignerWorkItem'

export default {
  name: 'designer',
  components: {
    DesignerWorkItem
  },
  data() {
    return {
      payload: null,
      designerName: null,
      years: []
    }
  },
  watch: {
    'payload.designer': function(newVal) {
      this.designerName = `${newVal.first_name} ${newVal.last_name}`

      // set years
      if (newVal.work) {
        let years = []

        // filter and map work years into years
        years = newVal.work.work.filter(work => {
          if (work.year !== '' && !years.includes(work.year)) {
            return true
          }
        }).map(years => years.year.trim())

        // filter and map research years into years
        years = years.concat(newVal.work.research.filter(research => {
          if (research.year !== '' && !years.includes(research.year)) {
            return true
          }
        }).map(years => years.year.trim()))

        // set years
        this.years = [...new Set(years)]
      }
    }
  },
  methods: {
    setData(payload) {
      this.payload = payload
      MetaService.updateMeta(payload)
    }
  },
  beforeRouteUpdate(to, from, next) {
    to.meta.postData.designer = to.params.designer

    DataService
      .getData(to.meta.postData)
      .then((payload) => {
        this.setData(payload)
        next()
      })
  },
  beforeRouteEnter(to, from, next) {
    to.meta.postData.designer = to.params.designer

    DataService
      .getData(to.meta.postData)
      .then((payload) => {
        next(vm => {
          vm.setData(payload)
        })
      })
  }
}
</script>

<style lang="scss" scoped>
.designer {
  @include page;

  &__information {
    display:flex;
    flex-wrap: wrap;
    padding:0 0 1rem 0;
    &-about {
      width:50%;
      padding:0 $grid-padding 0rem 0;
      &--year {
        display:none;
      }
      a {
        display:inline-block;
        margin:2rem 0 0 0;
        text-decoration:underline;
        // border-bottom:1px solid;
      }
    }
    &-info {
      &--year {
        margin:0 0 1rem 0;
      }
    }
  }

  &__work {
    width:100%;

    &-container {
      width:100%;
    }
    .work {
      width:100%;
      margin:0 0 2rem 0;
      &__items {
        width:100%;
        display:flex;
        flex-wrap:wrap;
        justify-content: flex-start;
      }
    }
  }
  @media screen and (max-width: $mobile) {
    &__information {
      &-about {
        width:100%;
        padding:0;
         &--year {
          display:block;
        }
        p {
          font-size:$body--m;
        }
      }
      &-info {
        padding:1rem 0 0 0;
        &--year {
          display:none;
        }
      }
    }
  }
}
</style>
